import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const PlusIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.9233 3.5C13.4756 3.5 13.9233 3.94772 13.9233 4.5V11.5H20.9233C21.4756 11.5 21.9233 11.9477 21.9233 12.5C21.9233 13.0523 21.4756 13.5 20.9233 13.5H13.9233V20.5C13.9233 21.0523 13.4756 21.5 12.9233 21.5C12.3711 21.5 11.9233 21.0523 11.9233 20.5V13.5H4.92334C4.37106 13.5 3.92334 13.0523 3.92334 12.5C3.92334 11.9477 4.37106 11.5 4.92334 11.5H11.9233V4.5C11.9233 3.94772 12.3711 3.5 12.9233 3.5Z"
            />
        </SvgIcon>
    );
};

export default PlusIcon;
